import MicroModal from 'micromodal';

/**
 * Generate the DOM element contents
 * @param {string} id Form ID
 * @param {string} color Class for custom color
 * @param {string} title Title for the modal
 * @param {text} text Text for the modal
 * @return {HTMLElement}
 */
const newsletterModalDOM = (id, color, title, text) => `
    <div class="newsletter-modal" id="newsletter-modal" aria-hidden="true">
      <div class="newsletter-modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="newsletter-modal__container ${color}" role="dialog" aria-modal="true" aria-labelledby="modal-title">

          <div class="newsletter-modal__top">
            <img class="newsletter-modal__icon" src="/wp-content/themes/color-genomics/assets/v2/img/icons/color-newsletter-email-icon.png" alt="Envelope Icon" width="37" height="37">
            <button class="newsletter-modal__close" aria-label="Close modal" data-micromodal-close>&times;</button>
          </div>

          <div class="newsletter-modal__header hide-on-submit">
            <h3 class="newsletter-modal__title headline headline--serif mb-space-2">${title}</h3>
            <p class="newsletter-modal__text text body mb-space-4">${text}</p>
          </div>

          <div class="newsletter-modal__form">
            ${window[id]}
          </div>

        </div>
      </div>
    </div>
  `;

const removeModal = (modalId) => {
  document.getElementById(modalId).remove();
};

const setModalHeight = (modal) => {
  const container = modal.querySelector('.newsletter-modal__container');
  if (container) {
    container.style.height = `${container.clientHeight + 1}px`;
  }
};

const newsletterModal = {
  init() {
    const newsletterModules = document.querySelectorAll(
      '[data-module="newsletter-modal"]'
    );

    // Checks for availiabilty of newsletter modals on the current page
    if (newsletterModules.length) {
      newsletterModules.forEach((newsletterModal) => {
        newsletterModal.addEventListener('click', (event) => {
          event.preventDefault();
          const newsletterModalButton = event.target.closest(
            '[data-module="newsletter-modal"]'
          );

          if (!newsletterModalButton) return;

          const {formid, color, title, text} = newsletterModalButton.dataset;

          const newsletterModalHTML = newsletterModalDOM(
            formid,
            color,
            title,
            text
          );

          document
            .getElementById('main')
            .insertAdjacentHTML('beforeend', newsletterModalHTML);

          // Construct the iframe and open it up
          MicroModal.show('newsletter-modal', {
            onShow: (modal) => {
              modal
                .querySelector('form')
                .addEventListener('submit', eventSubmitCustomForm); // eslint-disable-line no-undef
              setModalHeight(modal);
            },
            onClose: (modal) => removeModal(modal.id),
            openTrigger: '[data-element="newsletter-modal"]',
            openClass: 'is-open',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
          });
        });
      });
    }
  },
};

export default newsletterModal;
